import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_ID',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '55989413-b2a2-4807-842a-a8eed077a008',
  ''
);
